<script>
export default {
  name: "TopBar",
  computed: {
    name() {
      return this.$store.state.currentLoc === 0
        ? "Cities"
        : this.$store.state.locations[this.$store.state.currentLoc - 1].text;
    },
  },
  methods: {
    toggleMenu() {
      this.$store.commit("setMenuOpen", !this.$store.state.menuOpen);
    },
    refresh() {
      this.$store.dispatch('refreshAllLocations');
    }
  },
};
</script>
<template>
  <div class="topbar">
    <img class="icon-btn" src="../assets/icons/menu.svg" alt="Menu icon" @click="toggleMenu" />
    <div class="city">{{ name }}</div>
    <img class="icon-btn" src="../assets/icons/refresh.svg" alt="Add icon" @click="refresh" />
  </div>
</template>
<style lang="scss">
.topbar {
  height: var(--bar-height);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .city {
    font-weight: bold;
    font-size: 20px;
  }

  .icon-btn {
    width: 32px;
    margin: 8px;
  }
}
</style>
